import React from "react";

export default function ServiceCard({ icon, title, text }) {
  return (
    <div className="card h-100 border-0 shadow-sm position-relative overflow-hidden"
         style={{ transition: "transform 0.3s, box-shadow 0.3s" }}
         onMouseEnter={e => e.currentTarget.style.transform = "translateY(-10px) scale(1.03)"}
         onMouseLeave={e => e.currentTarget.style.transform = "translateY(0) scale(1)"}>
      <div className="card-body text-center">
        <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mx-auto mb-3"
             style={{ width: "60px", height: "60px", fontSize: "28px", transition: "transform 0.3s" }}
             onMouseEnter={e => e.currentTarget.style.transform = "scale(1.2)"}
             onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}>
          <i className={icon}></i>
        </div>
        <h5 className="fw-bold">{title}</h5>
        <p className="text-secondary">{text}</p>
      </div>
    </div>
  );
}
